import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, RotateCw } from "lucide-react";
import { restartStory } from "./StoryLayout";

// Narrator bar rendered on top of the real ICF screens (slides 4-7)
// when the URL has ?story=<slide>. Sticky at the bottom, never blocks
// content critical to the current beat.

export default function StoryNarratorBar({
    slide,
    total = 8,
    label,
    body,
    ctaLabel = "Next",
    nextTo,
}) {
    const navigate = useNavigate();
    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-[60]"
            data-testid="story-narrator-bar"
        >
            {/* progress ticker just above the bar */}
            <div className="h-[2px] bg-neutral-100">
                <div
                    className="h-full bg-[#C2410C] transition-all duration-500"
                    style={{ width: `${(slide / total) * 100}%` }}
                />
            </div>

            <div className="bg-[#0A0A0A] text-white border-t border-[#262626]">
                <div className="max-w-6xl mx-auto px-4 md:px-6 py-3 flex items-start gap-4 flex-wrap">
                    <div className="flex items-center gap-3 shrink-0">
                        <div className="mono text-[10px] uppercase tracking-wider text-neutral-500">
                            {slide} / {total}
                        </div>
                        <div className="overline text-[9px] text-[#C2410C]">
                            {label}
                        </div>
                    </div>
                    <p className="text-[12.5px] text-neutral-200 leading-relaxed max-w-3xl">
                        {body}
                    </p>
                    <div className="ml-auto flex items-center gap-3 shrink-0">
                        <button
                            type="button"
                            onClick={() => restartStory(navigate)}
                            data-testid="narrator-restart"
                            className="text-[11px] text-neutral-500 hover:text-white inline-flex items-center gap-1"
                        >
                            <RotateCw size={11} /> Restart
                        </button>
                        <Link
                            to="/icf/extract"
                            data-testid="narrator-skip"
                            className="text-[11px] text-neutral-500 hover:text-white"
                        >
                            Skip
                        </Link>
                        <button
                            type="button"
                            onClick={() => navigate(nextTo)}
                            data-testid="narrator-next"
                            className="inline-flex items-center gap-2 bg-white text-[#0A0A0A] text-[12px] px-3 py-2 rounded-sm hover:bg-neutral-200 transition-colors"
                        >
                            {ctaLabel}
                            <ArrowRight size={12} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
